import { render, staticRenderFns } from "./SalaryStatistics.htm?vue&type=template&id=6fbbfaa6&scoped=true&"
import script from "./SalaryStatistics.ts?vue&type=script&lang=js&"
export * from "./SalaryStatistics.ts?vue&type=script&lang=js&"
import style0 from "./SalaryStatistics.scss?vue&type=style&index=0&id=6fbbfaa6&lang=scss&scoped=true&"
import style1 from "./SalaryStatisticsLayout.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbfaa6",
  null
  
)

export default component.exports